<template>
  <div class="orders-by-salesperson-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'OrdersBySalespersonChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#3c58e7'],
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          title: {
            text: 'Salesperson',
          },
        },
        tooltip: {
          y: {
            formatter: (val) => {
              if (this.showValue) {
                return '$' + val.toLocaleString()
              }
              return val + ' orders'
            },
          },
        },
      }
    },
    categories() {
      return _.map(this.data, (d) => {
        const email = d._id || 'Unknown'
        return email.split('@')[0]
      })
    },
    series() {
      const values = _.map(this.data, (d) => {
        return this.showValue ? d.totalValue || 0 : d.count
      })
      return [
        {
          name: this.showValue ? 'Total Value' : 'Orders',
          data: values,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



